import { Platform } from 'react-native';
import {
  CardAction,
  TCardActionProps,
} from '@/common/components/CardAction/CardAction';
import { Icon } from '@/common/components/Icons/Icon';
import * as Linking from 'expo-linking';
import { Href, useRouter } from 'expo-router';
import { Stack } from '../Stack/Stack';

export interface TCardActionLinkInternalProps extends TCardActionProps {
  href: Href;
  external?: false;
  withAnchor?: boolean;
}

export interface TCardActionLinkExternalProps extends TCardActionProps {
  href: string;
  external: true;
}

export type TCardActionLinkProps =
  | TCardActionLinkInternalProps
  | TCardActionLinkExternalProps;

export function CardActionLink(cardProps: TCardActionLinkProps) {
  const router = useRouter();

  const icon = cardProps.external ? (
    <Icon icon="arrow-up-right" />
  ) : (
    <Icon icon="chevron-right" />
  );

  return (
    <CardAction
      {...cardProps}
      onPress={() => {
        if (cardProps.external) {
          return Platform.OS === 'web'
            ? window.open(cardProps.href, '_blank')
            : Linking.openURL(cardProps.href);
        }

        if (cardProps.onPress) {
          cardProps.onPress();
        }

        return router.navigate(cardProps.href, {
          withAnchor: Platform.OS !== 'web' ? cardProps.withAnchor : false,
        });
      }}
      action={
        <Stack horizontal gap="sm" align="center">
          {cardProps.action}
          {!cardProps.disabled ? icon : undefined}
        </Stack>
      }
    />
  );
}
